import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Tabs, Grid } from "@mui/material";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import MonthlyTransaction from "./MonthlyTransaction";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      className="tabpanel-data"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
}

const BasicTabs = forwardRef((props, ref) => {
  const childRef2 = useRef();
  const [counter, setCount] = useState(0);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const hideIncome = useSelector(
    (state) => state.userReducer.hideIncome
  );

  const handleCallback = (swipedir) =>{
    if(swipedir=="left" && value === 0){
      setValue(1);
    }
    else if(swipedir == "right" && value=== 1){
      setValue(0);
    }
  }

  useEffect(() => {}, [props]);

  useImperativeHandle(ref, () => ({
    callFromTransaction() {
      let countVal = counter + 1;
      setCount(countVal);
    },
  }));

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          className="tabs-btns"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tooltip title="Expense">
            <Tab  label="Expense" aria-label="phone" />
          </Tooltip>
          { hideIncome === false && (
          <Tooltip title="Income">
            <Tab label="Income" aria-label="budget" />
          </Tooltip>
          )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <MonthlyTransaction count={counter} budgetType="expense" parentCallback = {handleCallback} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MonthlyTransaction count={counter} budgetType="income" parentCallback = {handleCallback} />
      </TabPanel>
    </Box>
  );
});

export default BasicTabs;
